<template>
  <div
    class="BaseCapabilities">
    <div
      v-for="possibleCapability in possibleCapabilities"
      class="_wrapper"
      :key="possibleCapability.value">
      <BaseCapability
        :included="isCapabilityIncluded(possibleCapability.label, capabilities)"
        :icon="possibleCapability.icon"
        :to="{
          name: 'search',
          query: {
            capability: possibleCapability.label,
          },
        }">
        {{ possibleCapability.label }}
      </BaseCapability>
    </div>
  </div>
</template>

<script>
import CAPABILITIES from '@/data/capabilities';
import BaseCapability from '@/components/BaseCapability.vue';

export default {
  name: 'BaseCapabilities',

  components: {
    BaseCapability,
  },

  data() {
    return {
      possibleCapabilities: CAPABILITIES,
    };
  },

  props: {
    capabilities: { type: [Array, String], default: null },
  },

  methods: {
    isCapabilityIncluded(thisCapabilityValue, includedCapabilities = null) {
      const sanitizedCapabilities = (typeof includedCapabilities === 'string')
        ? [includedCapabilities]
        : includedCapabilities;
      const includedValues = sanitizedCapabilities || [];
      const capabilityIncluded = includedValues
        .map((iv) => ((typeof iv === 'object') ? iv.label.toLowerCase() : iv.toLowerCase()))
        .includes(thisCapabilityValue.toLowerCase());
      return capabilityIncluded;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/_variables';

.BaseCapabilities {
  display: flex;
  width: calc(100% + 10px);
  margin-left: -5px;
  flex-wrap: wrap;
}

.BaseCapabilities ._wrapper {
  flex: 0 1 50%;
  max-width: 50%;
  padding: 5px;
}
</style>
